import type { FaireProductEntity } from "../../entity_types/product";

export const p_n5z9w7jfyq: FaireProductEntity = {
  token: "p_n5z9w7jfyq",
  type: "product",
  name: "Scout Original Dipping Sauce & Spread",
  brandToken: "b_mx8mk6w8xb",
  brandName: "Scout Trading Co",
  imageUrl:
    "https://cdn.faire.com/fastly/e45cf44960829fc8d870e5a0cdfa289e44b278b873b51e98ff8cda575d0acb3d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/eb31341b9d7ee0e4a7586f424946cf4a92eda89c98f0b7420127c5e45268af2e.png",
    "https://cdn.faire.com/fastly/26a947dab1d491400ba0f5592355a8de7a322dfaf5f0ae7179b20cd4da4b4dfe.jpeg",
    "https://cdn.faire.com/fastly/01112cc0a19429cfb7fc4cadc9f2c9e7749b4711073a3862cb7a52b591490f7c.jpeg",
    "https://cdn.faire.com/fastly/3502bd1f48df7484d481f05c2e9bb6541e7721b730adf46fde9487ec856cbf2c.png",
    "https://cdn.faire.com/fastly/a1ec70ba0512ce2c653e3eb9bcb204da4632b5434f46dab7fca8ba1d6f222428.jpeg",
    "https://cdn.faire.com/fastly/523c79bbb4dd51c652d63618aae049821fea4c6483af5606eed545872cd3c1dd.jpeg",
    "https://cdn.faire.com/fastly/ecc54f9ad56989e4a08112e82bb87761ac21fab0b9481aec43e803cbdeed0e61.png",
    "https://cdn.faire.com/fastly/9d42f50c91f7d0b6ea3475969b0cb9821cdfc9e075f5e3c696525251fe4941ba.png",
    "https://cdn.faire.com/fastly/809c84155e6f720886ac8e28563cdbeb0293c57c56d63b49d7c7aadd86dda384.jpeg",
    "https://cdn.faire.com/fastly/7b2f401ff3ad1f57cf2b6a45dfccdbaaefc64b2e919ec4c931329fe98510e938.jpeg",
  ],
  priceDollars: 5.33,
  description:
    "Not your Grandma’s dipping sauce. But actually, it is. An original family recipe that is uniquely sweet. Is it a dip? Yes. Is it a sauce? For sure. Is it a spread? Absolutely. Pretzels, charcuterie, ham sandwich, Bloody Mary, brat, hot dog, cocktail weenie, fries, ingredient for a recipe — it’s a tasty and versatile dipping sauce!",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:31.546Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
